module.exports = __webpack_public_path__ + "files/9a2214156d13462315c4a3fad97c51fb.png";